import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loadAllPostPreview,
  selectPostPreview,
  selectFilteredPost,
} from "./postPreviewSlice";

import PostListItems from "./PostListItems";

const PostPreview = ({ name, term }) => {
  const dispatch = useDispatch();

  const postPreview = useSelector(selectPostPreview);

  const filteredPost = useSelector(selectFilteredPost);

  useEffect(() => {
    dispatch(loadAllPostPreview(name));
  }, [dispatch, name]);

  if (term === "") {
    return (
      <div className="post-preview-child">
        <h2 className="post-preview-title">{name}</h2>

        {postPreview.map((item) => (
          <div className="post-list-item" key={item.data.id}>
            {<PostListItems post={item} />}
          </div>
        ))}
      </div>
    );
  } else {
    return (
      <div className="post-preview-child">
        <h2 className="post-preview-title">{name}</h2>

        {filteredPost.map((post) => (
          <div className="filtered-post" key={post.data.id}>
            <PostListItems post={post} />
          </div>
        ))}
      </div>
    );
  }
};

export default PostPreview;
